(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/pay-button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/pay-button.js');
"use strict";


const PayButton = _ref => {
  let {
    sum,
    onClick,
    disabled = false,
    className
  } = _ref;
  const Button = svs.ui.Button;
  const label = svs.core.config.data.svsconfig.isSelfService ? "L\xE4gg i varukorg (".concat(svs.utils.format.Currency(sum), " kr)") : "Betala ".concat(svs.utils.format.Currency(sum), " kr");
  const {
    animateNumbers,
    animateButtonPlop
  } = svs.tur.ReactPayfooter.utils;
  const currentSum = React.useRef(0);
  const payButtonRef = React.useRef();
  React.useEffect(() => {
    if (payButtonRef.current) {
      animateButtonPlop({
        element: payButtonRef.current
      });
      animateNumbers({
        element: payButtonRef.current,
        from: currentSum.current,
        to: sum
      });
      currentSum.current = sum;
    }
  }, [sum]);
  if (isNaN(Number(sum))) return null;
  return React.createElement(Button, {
    className: "payfooter-button ".concat(className),
    disabled: disabled,
    elemRef: payButtonRef,
    focus: true,
    onClick: onClick
  }, label);
};
svs.tur.ReactPayfooter.PayButton = PayButton;

 })(window);